import { Btn } from "@/components/shared";
import { Download, Share2, CheckSquare, Trash2, X, FileText } from "lucide-react";

export function BulkToolbar({ selectMode, selectedCount, visibleCount, folders, folderLabel, isAdmin, isClient, busy, actions }) {
  const { toggleMode, selectAll, zipSelected, zipAll, openShare, openReport, openReportAll, move, remove } = actions;
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="photo-toolbar">
      <Btn variant="secondary" data-testid="select-mode-btn" onClick={toggleMode}>{selectMode ? <X size={14} /> : <CheckSquare size={14} />} {selectMode ? "Done" : "Select"}</Btn>
      {selectMode && <Btn variant="secondary" data-testid="select-all-btn" onClick={selectAll}>Select all ({visibleCount})</Btn>}
      {selectMode && selectedCount > 0 && (
        <>
          <span className="font-mono text-xs text-[#FF5722]" data-testid="selected-count">{selectedCount} selected</span>
          <Btn data-testid="download-selected-btn" onClick={zipSelected} disabled={busy}><Download size={14} /> Download ZIP</Btn>
          {!isClient && <Btn variant="secondary" data-testid="report-selected-btn" onClick={openReport} disabled={busy}><FileText size={14} /> Photo Report PDF</Btn>}
          {isAdmin && <Btn data-testid="share-selected-btn" onClick={openShare}><Share2 size={14} /> Share with client</Btn>}
          {!isClient && (
            <select data-testid="move-select" value="" onChange={(e) => e.target.value && move(e.target.value)} className="h-9 bg-zinc-950 border-2 border-zinc-700 text-zinc-200 font-mono text-xs px-2">
              <option value="">Move to folder…</option>
              {folders.map((f) => <option key={f} value={f}>{f}</option>)}
            </select>
          )}
          {!isClient && <Btn variant="danger" data-testid="delete-selected-btn" onClick={remove}><Trash2 size={14} /></Btn>}
        </>
      )}
      {!selectMode && <Btn variant="secondary" data-testid="download-all-btn" onClick={zipAll} disabled={busy}><Download size={14} /> Download {folderLabel} (ZIP)</Btn>}
      {!selectMode && !isClient && <Btn variant="secondary" data-testid="report-all-btn" onClick={openReportAll} disabled={busy}><FileText size={14} /> Photo Report PDF</Btn>}
    </div>
  );
}
